import React from "react";

interface FilterPageLayoutProps {
  filter: React.ReactNode;
  children: React.ReactNode;
}

const FilterPageLayout: React.FC<FilterPageLayoutProps> = ({
  filter,
  children,
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <div style={{ paddingBlock: 12 }}>{filter}</div>
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          // overscrollBehaviorY: "contain",
          // overflowAnchor: "none",
          // overscrollBehavior: "none",
          // WebkitOverflowScrolling: "touch",
        }}
      >
        {children}
      </div>
      <div style={{ height: "2px" }}></div>
    </div>
  );
};

export default FilterPageLayout;
